import React, { useState, useEffect } from 'react';
import * as FaIcons from 'react-icons/fa';
import SafeIcon from '../common/SafeIcon';
import { openWhatsApp } from '../lib/whatsapp';

const { FaWhatsapp } = FaIcons;

function WhatsAppFloat() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 300);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <div className={`wa-float ${visible ? 'is-visible' : ''}`}>
      <span className="wa-float-label">Contact Us</span>
      <button
        type="button"
        className="wa-float-btn"
        aria-label="Contact us on WhatsApp"
        onClick={() => openWhatsApp()}
      >
        <SafeIcon icon={FaWhatsapp} />
      </button>
    </div>
  );
}

export default WhatsAppFloat;
